module.exports = __webpack_public_path__ + "resource/img/logo-bbi.666c7afc.png";